import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en: {
        translation: {
          brand: "Stellar",
          menu: {
            services: "Services",
            industries: "Industries",
            products: "Products",
            company: "Company",
            innovation: "Innovation",
            contact: "Contact",
            careers: "Careers",
            viksitbharat2047: "viksitbharat#2047",
            digitalEngineering: "Digital Engineering",
            cloudData: "Cloud and Data",
            cybersecurity: "Cybersecurity",
            operations: "Operations",
            mobility: "Mobility",
            sustainability: "Sustainability",
            technology: "Technology",
            manufacturing: "Manufacturing",
            energyUtilities: "Energy and Utilities",
            publicSector: "Public Sector",
            about: "About Stellar",
            workAt: "Work at Stellar",
            opportunities: "Opportunities",
          },
          minor: {
            // Company
            ourStory: "Our Story",
            coreCapabilities: "Core Capabilities",
            ourProducts: "Our Products",
            // Innovation
            rdFacilities: "R&D Facilities",
            patents: "Patents & Breakthroughs",
            sustainability: "Sustainability Initiatives",
            // Contact
            reachOut: "Reach Out",
            visitUs: "Visit Us",
            // Careers
            whyJoin: "Why Join Us",
            lifeAt: "Life at Stellar",
            employeeStories: "Employee Stories",
            engineeringRoles: "Engineering Roles",
            internships: "Internships",
            salesMarketing: "Sales & Marketing",
            productEngineering: "Product Engineering",
            platformModernization: "Platform Modernization",
            embeddedSystems: "Embedded Systems",
            experienceEngineering: "Experience Engineering",
            cloudFoundation: "Cloud Foundation",
            dataLakehouse: "Data Lakehouse",
            aiEnablement: "AI Enablement",
            securityStrategy: "Security Strategy",
            threatResponse: "Threat Response",
            resilience: "Resilience",
            connectedPlatforms: "Connected Platforms",
            fleetIntelligence: "Fleet Intelligence",
            experiencePlatforms: "Experience Platforms",
            gridModernization: "Grid Modernization",
            esgAnalytics: "ESG Analytics",
            aiData: "AI and Data",
            securityTrust: "Security and Trust",
            smartFactories: "Smart Factories",
            digitalTwins: "Digital Twins",
            predictiveMaintenance: "Predictive Maintenance",
            ourPurpose: "Our Purpose",
            byNumbers: "By Numbers",
            areasOfExpertise: "Areas of Expertise",
            platforms: "Platforms",
            clientImpact: "Client Impact",
            insights: "Insights",
            innovationLabs: "Innovation Labs",
            breakthroughs: "Breakthroughs",
            innovationTeam: "Innovation Team",
            consultingRoles: "Consulting Roles",
          },
          search: "Search...",
          english: "English",
          hindi: "Hindi",
          fr: "French",
          de: "German",
          profile: "Sign IN ",
          settings: "My Invoice",
          logout: "My Orders"
        },
      },
      hi: {
        translation: {
          brand: "Stellar",
          menu: {
            services: "सेवाएँ",
            industries: "उद्योग",
            products: "उत्पाद",
            company: "कंपनी",
            innovation: "नवाचार",
            contact: "संपर्क करें",
            careers: "करियर",
            viksitbharat2047: "viksitbharat#2047",
            digitalEngineering: "डिजिटल इंजीनियरिंग",
            cloudData: "क्लाउड और डेटा",
            cybersecurity: "साइबर सुरक्षा",
            operations: "संचालन",
            mobility: "मोबिलिटी",
            sustainability: "सस्टेनेबिलिटी",
            technology: "टेक्नोलॉजी",
            manufacturing: "निर्माण",
            energyUtilities: "ऊर्जा और यूटिलिटीज",
            publicSector: "सार्वजनिक क्षेत्र",
            about: "Stellar के बारे में",
            workAt: "Stellar में काम करें",
            opportunities: "अवसर",
          },
          minor: {
            ourStory: "हमारी कहानी",
            coreCapabilities: "मुख्य क्षमताएँ",
            ourProducts: "हमारे उत्पाद",
            rdFacilities: "आर एंड डी सुविधाएँ",
            patents: "पेटेंट और उपलब्धियाँ",
            sustainability: "सस्टेनेबिलिटी इनिशिएटिव्स",
            reachOut: "संपर्क करें",
            visitUs: "हमसे मिलें",
            whyJoin: "हममें क्यों शामिल हों",
            lifeAt: "Stellar में जीवन",
            employeeStories: "कर्मचारी कहानियाँ",
            engineeringRoles: "इंजीनियरिंग भूमिकाएँ",
            internships: "इंटर्नशिप",
            salesMarketing: "सेल्स और मार्केटिंग",
            productEngineering: "प्रोडक्ट इंजीनियरिंग",
            platformModernization: "प्लेटफॉर्म आधुनिकीकरण",
            embeddedSystems: "एंबेडेड सिस्टम्स",
            experienceEngineering: "एक्सपीरियंस इंजीनियरिंग",
            cloudFoundation: "क्लाउड फाउंडेशन",
            dataLakehouse: "डेटा लेकहाउस",
            aiEnablement: "एआई एनेबलमेंट",
            securityStrategy: "सुरक्षा रणनीति",
            threatResponse: "थ्रेट रिस्पॉन्स",
            resilience: "रिज़िलिएंस",
            connectedPlatforms: "कनेक्टेड प्लेटफॉर्म्स",
            fleetIntelligence: "फ्लीट इंटेलिजेंस",
            experiencePlatforms: "एक्सपीरियंस प्लेटफॉर्म्स",
            gridModernization: "ग्रिड आधुनिकीकरण",
            esgAnalytics: "ईएसजी एनालिटिक्स",
            aiData: "एआई और डेटा",
            securityTrust: "सुरक्षा और भरोसा",
            smartFactories: "स्मार्ट फैक्ट्रियां",
            digitalTwins: "डिजिटल ट्विन्स",
            predictiveMaintenance: "प्रीडिक्टिव मेंटेनेंस",
            ourPurpose: "हमारा उद्देश्य",
            byNumbers: "आंकड़ों में",
            areasOfExpertise: "विशेषज्ञता के क्षेत्र",
            platforms: "प्लेटफॉर्म्स",
            clientImpact: "क्लाइंट प्रभाव",
            insights: "इनसाइट्स",
            innovationLabs: "इनोवेशन लैब्स",
            breakthroughs: "ब्रेकथ्रूज",
            innovationTeam: "इनोवेशन टीम",
            consultingRoles: "कंसल्टिंग भूमिकाएँ",
          },
          search: "खोजें...",
          english: "अंग्रेज़ी",
          hindi: "हिंदी",
          fr: "फ्रेंच",
          de: "जर्मन",
          profile: "प्रोफ़ाइल",
          settings: "सेटिंग्स",
          logout: "लॉग आउट"
        },
      },
    },
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });

export default i18n;
